import { render, staticRenderFns } from "./wasteTruck.vue?vue&type=template&id=a61c7b30&scoped=true"
import script from "./wasteTruck.vue?vue&type=script&lang=js"
export * from "./wasteTruck.vue?vue&type=script&lang=js"
import style0 from "./wasteTruck.vue?vue&type=style&index=0&id=a61c7b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c7b30",
  null
  
)

export default component.exports